import React from "react";
import AddAssignmentTemplateSPVModal from "features/Dealers/DealerDetails/AdditionalDocuments/AddAssignmentTemplateSPVModal";
import {
  getAssignmentTemplatesSPV,
  approveAdditionalDocument,
  downloadAdditionalDocument,
} from "features/Dealers/DealerDetails/AdditionalDocuments/actions";
import AdditionalDocumentTable from "features/AdditionalDocuments/AdditionalDocumentTable";

const AssignmentTemplateSpv = ({ dealerId }) => {
  return (
    <AdditionalDocumentTable
      dealerId={dealerId}
      loadAction={getAssignmentTemplatesSPV}
      emptyMessage="No Assignment Template from SPV"
      AddModal={AddAssignmentTemplateSPVModal}
      approveAction={approveAdditionalDocument}
      downloadAction={downloadAdditionalDocument}
    />
  );
};

export default AssignmentTemplateSpv;
